import { Dayjs } from "dayjs";
import { LoadingBlock } from "../UI/Loading/LoadingRows.tsx";
import { TeacherTierBadge } from "../Franchisee/TeacherAssignmentCap/TeacherTierBadge.tsx";
import { CapReachedBadge } from "../Franchisee/TeacherAssignmentCap/CapReachedBadge.tsx";
import { useTeacherWeekAssignmentCap } from "../Franchisee/TeacherAssignmentCap/useTeacherWeekAssignmentCap.ts";
import { formatShare } from "../Franchisee/TeacherActivity/activityFormat.ts";
import { shareOf } from "../Franchisee/TeacherActivity/shareOf.ts";

export function TeacherWeeklyCapSummary({
  teacherId,
  weekStart,
}: {
  teacherId: string;
  weekStart: Dayjs;
}) {
  const { weekAssignmentCap, loading } = useTeacherWeekAssignmentCap({
    teacherId,
    weekStart,
  });

  if (loading) return <LoadingBlock sizeClassName={"h-6 w-96"} />;
  if (!weekAssignmentCap) return null;

  const {
    offeredSlots,
    assignedClassRooms,
    weeklyCapWithCurrentTier: weeklyCap,
  } = weekAssignmentCap;
  const capOrShareOfOfferedSlots = weeklyCap
    ? `cap ${weeklyCap.maxAssignableClassRooms} (${weeklyCap.maxPercentOfWeeklyAvailability}%)`
    : formatShare(shareOf(assignedClassRooms, offeredSlots));

  return (
    <div className={"flex flex-wrap items-center gap-x-3 gap-y-2 text-sm"}>
      <span className={"text-xs font-medium text-slate-500"}>
        Weekly assignment cap
      </span>
      {weeklyCap && <TeacherTierBadge tier={weeklyCap.tier} />}
      {offeredSlots === 0 ? (
        <span className={"text-slate-400"}>
          No availability offered this week
        </span>
      ) : (
        <span className={"text-slate-600"}>
          <span className={"font-semibold text-slate-800"}>
            {assignedClassRooms}
          </span>{" "}
          of {offeredSlots} offered slots assigned · {capOrShareOfOfferedSlots}
        </span>
      )}
      {weeklyCap?.hasBeenReached && <CapReachedBadge />}
      {!weeklyCap && (
        <span className={"text-xs text-slate-400"}>
          Past week: the tier and cap applied to each class are in its
          assignment history
        </span>
      )}
    </div>
  );
}
